export default function getViewportWidth() {
	return Math.max(
		document.documentElement.clientWidth,
		window.innerWidth || 0,
	);
}
